<script setup>
    /**
     * Vue Scripts
     */
    import {ref} from "vue";
    import {createWidget} from '@typeform/embed'
    import '@typeform/embed/build/css/widget.css'

    /**
     * Vue Components
     */
    import SignupForm from "@global/StudyKikForm/SignupForm/SignupForm.vue";
    import SignupThankYou from "@global/StudyKikForm/SignupThankYou/SignupThankYou.vue";

    const {
        api,
        content,
        formLabels,
        studyKikId,
        images,
        thankYou,
        taOverride,
        title,
    } = STUDYKIK;

    const step = ref('signup')
    const stepTwo = ref(null)

    const onSignupCompleted = patient => {
        const {questionnaireFormId, uuid} = patient;
        if (!questionnaireFormId) {
            step.value = 'thank-you';
            return;
        }

        step.value = 'form';

        /**
         * Uses @typeform/embed to create the form embed
         * from StudyKik
         */
        createWidget(questionnaireFormId, {
            container: stepTwo.value,
            // height: 520,
            hidden: {
                patient_uuid: uuid
            },
            onSubmit: (() => {
                step.value = 'thank-you';
            })
        })
    }
</script>

<template>
    <div class="studykik-container">
        <div class="studykik-container__content">
            <h3
                v-if="title"
                v-html="title"
            />
            <div
                v-if="content"
                v-html="content"
            />
        </div>
        <div
            v-show="step === 'signup'"
            class="studykik-container__step step-one"
        >
            <SignupForm
                @signup-completed="onSignupCompleted"
            />
        </div>

        <div
            v-show="step === 'form'"
            class="studykik-container__step step-two"
        >
            <div ref="stepTwo"></div>
        </div>
        <div
            v-show="step === 'thank-you'"
            class="studykik-container__step step-three"
        >
            <SignupThankYou />
        </div>
    </div>
</template>

<script>
    export default {
        name: "StudyKik Form"
    }
</script>

<style scoped lang="scss">

</style>
